// extracted by mini-css-extract-plugin
export default {"tooltip":"UU-z","arrow":"VU-z"};